import React from "react";
import styled from "styled-components";
import ProjectSection from "./ProjectSection";
import WorkSection from "./WorkSection";

const Home = () => {
	return (
		<>
			<StyledMain
				data-aos="fade-up"
				data-aos-offset="200"
				data-aos-delay="50"
				data-aos-duration="1000"
				data-aos-easing="ease-in-out"
				data-aos-once="true"
				data-aos-anchor-placement="top-center"
			>
				<div className="main-cont">
					<h1 className="main-title">
						<span className="main-title-thin">
							Hello, I'm Ekene
						</span>
						<br />

						<span className="main-title-thick">
							Oshai
							<span className="main-title-decimal">.</span>
						</span>
					</h1>
					<div className="main-description">
						<img src="./images/line.svg" alt="" className="line" />

						<p>
							Creative and self-driven design professional with
							experience in creating and delivering elegant,
							innovative design solutions that excite consumers
							and grow iconic brands. Skilled in leading multiple
							projects from concept through to completion.
							Hands-on in transforming complex information and
							concepts into attractive, human-centred designs.
						</p>
					</div>
					<div className="main-cont-arrow">
						{" "}
						<img src="./images/arrow-down.svg" alt="" />
					</div>

					<img
						src="./images/SuperToroid-2.png"
						alt=""
						className="donut accessories"
					/>
					<img
						src="./images/cube.png"
						alt=""
						className="accessories cube"
					/>
					<img
						src="./images/black-cube.png"
						alt=""
						className="accessories black-cube"
					/>
				</div>
			</StyledMain>

			<ProjectSection />
			<WorkSection />
		</>
	);
};

export default Home;

const StyledMain = styled.main`
	min-height: 100vh;
	padding-top: 150px;
	padding-bottom: 80px;
	overflow: hidden;

	@media (min-width: 750px) {
		padding-top: 40px;
	}

	@media (min-width: 1440px) {
		padding-top: 50px;
	}

	.accessories {
		width: 200px;
	}

	.main-cont {
		position: relative;
		margin-top: 40px;
		padding: 16px;

		@media (min-width: 750px) {
			max-width: 700px;
			margin: 0 auto;
			margin-top: 128px;
			padding: 0;
		}

		@media (min-width: 1000px) {
			max-width: 800px;
			margin: 0 auto;
			margin-top: 160px;
			padding: 0;
		}
	}

	.main-title {
		font-size: 4rem;
		letter-spacing: 4px;
		line-height: 1.1;

		@media (min-width: 750px) {
			line-height: 1.2;
		}

		@media (min-width: 1000px) {
			font-size: 5rem;
		}
	}

	.main-title-thin {
		font-weight: 300;
	}
	.main-title-thick {
		font-weight: 600;
	}
	.main-title-decimal {
		color: rgba(157, 0, 212, 1);
	}

	.main-description {
		display: flex;
		margin-top: 72px;
		gap: 32px;

		img {
			margin-left: 40px;

			@media (min-width: 750px) {
				opacity: 1;
				margin-left: 40px;
			}

			@media (min-width: 1000px) {
				margin-left: 60px;
			}
		}
		p {
			padding-top: 12px;
			font-family: AxiformaBook;
			line-height: 1.7;
			@media (min-width: 750px) {
				padding-top: 24px;
				font-size: 1.1rem;
			}

			@media (min-width: 1000px) {
				padding-top: 16px;

				width: 66%;
				// border: solid;
			}
		}
		@media (min-width: 1000px) {
			margin-top: 64px;
		}
	}

	.main-cont-arrow {
		margin-top: 72px;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 50px;
		}

		@keyframes bounce {
			0% {
				transform: translateY(0);
			}
			100% {
				transform: translateY(-50px);
			}
		}
		& {
			animation: bounce 0.8s infinite alternate;
		}
	}

	.donut {
		position: absolute;
		left: 0px;
		top: 265px;
		z-index: 1;
		width: 80px;

		@media (min-width: 550px) {
			left: 0px;
			top: 265px;
		}

		@media (min-width: 750px) {
			left: -16px;
			top: 176px;
		}
		@media (min-width: 1000px) {
			width: 200px;
			left: -170px;
			bottom: 150px;
		}

		@keyframes bounce {
			0% {
				transform: translateY(0);
			}
			50% {
				transform: translateY(-15px);
			}

			100% {
				transform: translateY(-5px);
			}
		}
		& {
			animation: bounce 0.9s infinite alternate;
		}
	}

	.cube {
		position: absolute;
		width: 120px;
		z-index: -1;
		right: -14px;
		top: -110px;
		@media (min-width: 750px) {
			right: -40px;
			top: -63px;
		}

		@keyframes bounce {
			0% {
				transform: translateY(0);
			}
			100% {
				transform: translateY(-10px);
			}
		}
		& {
			animation: bounce 1s infinite alternate;
		}
	}

	.black-cube {
		position: absolute;
		right: -5%;
		bottom: -50px;

		z-index: -1;
		width: 150px;
		filter: blur(16px);
		-webkit-filter: blur(16px);

		@keyframes bounce {
			0% {
				transform: translateY(0);
			}
			100% {
				transform: translateY(-10px);
			}
		}
		& {
			animation: bounce 1s infinite alternate;
		}

		@media (min-width: 750px) {
			right: 0;
		}
	}
`;
